export const europe = ['Austria','Great Britain','Denmark','Cyprus','Italy', 'Spain','Germany','Russia', 'France'];

export const europeImages = europe.map((country) => '/places/'+country.toLocaleLowerCase()+".jpg");

export const africa = ['Egypt','Ghana','Ivory Coast', 'Moroco', 'Rwanda', 'Senegal', 'South Africa', 'Tunisia'];
export const africaImages = africa.map((country) => '/places/'+country.toLocaleLowerCase()+".jpg");
